import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "xml:space": "preserve",
  fill: "currentColor",
  viewBox: "0 0 30 19"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "m24.12 17.44-5.25-4.98c.65-.7 1.18-1.51 1.51-2.44a7.302 7.302 0 0 0-6.86-9.8c-4.03 0-7.3 3.27-7.3 7.3s3.27 7.3 7.3 7.3c1.51 0 2.95-.47 4.14-1.3l5.35 5.08zM7.83 7.52c0-3.14 2.56-5.7 5.7-5.7a5.71 5.71 0 0 1 5.36 7.65 5.73 5.73 0 0 1-5.36 3.75c-3.14 0-5.7-2.55-5.7-5.7" }, null, -1)
  ]))]))
}
export default { render: render }